import {IBenefit, ISector, IService, ISpecialty} from '../interfaces/professional/Professional';


export const benefitsTranslate = (locale: "en" | "fr", items?: IBenefit[]) => {
  return items?.map(it => ({...it, title: it?.translated ? it?.translated[locale] : it.title})) || [];
}

export const specialtiesTranslate = (locale: "en" | "fr", items?: ISpecialty[]) => {
  return items?.map(it => ({...it, title: it?.translated ? it?.translated[locale] : it.title})) || [];
}

export const mapIterationSectorDataTranslations = (sector: ISector, locale: "en" | "fr") => {
  return {
    ...sector,
    title: sector?.translated ? sector?.translated[locale] : sector.title,
    benefits: benefitsTranslate(locale, sector.benefits),
    specialties: specialtiesTranslate(locale, sector.specialties)
  }
}

export const sectorsTranslation = (sectors: ISector[], locale: "en" | "fr") => {
  return sectors.map(item => mapIterationSectorDataTranslations(item, locale));
};

export const serviceTranslation = (service: IService, locale: "en" | "fr"): IService => {
  return {
    ...service,
    helps: benefitsTranslate(locale, service.helps),
    specialties: specialtiesTranslate(locale, service.specialties)
  };
};

export const sectorTranslation = (sectors: ISector[], locale: "en" | "fr", sector?: ISector) => {
  const filtered = sectors.filter(item => item.id === sector?.id);
  return sectorsTranslation(filtered, locale).find(item => item.id === sector?.id);
};
